import { render } from "./ProductBottomBar.vue?vue&type=template&id=500d4dc2&scoped=true"
import script from "./ProductBottomBar.vue?vue&type=script&lang=js"
export * from "./ProductBottomBar.vue?vue&type=script&lang=js"

import "./ProductBottomBar.vue?vue&type=style&index=0&id=500d4dc2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-500d4dc2"]])

export default __exports__